/**
 * @fileoverview Tira os acentos de um texto ("ligação" → "ligacao"), para
 * buscas que não dependem de o usuário digitar acento.
 */

const stripAccents = (text) => String(text || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export default stripAccents;
